import './App.scss';

import PropTypes from 'prop-types';
import React from 'react';
import SearchContainer from './containers/SearchContainer';
import { StateProvider } from './state';

const SearchWithState = ({ clientCode, isPreview }) => (
	<StateProvider client={clientCode} isPreview={isPreview}>
		<SearchContainer />
	</StateProvider>
);

SearchWithState.propTypes = {
	clientCode: PropTypes.string,
	isPreview: PropTypes.bool,
};

const App = (props) => {
	if (props.isSSR) {
		return (
			<div id="search-root">
				<SearchWithState {...props} />
			</div>
		);
	} else {
		return (
			<SearchWithState {...props} />
		)
	}
};

export default App;
